const getRandomInt = (min, max) =>
  Math.floor(Math.random() * (max - min + 1) + min);

const getRandomMonth = () => {
  const months = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  ];
  return months[getRandomInt(0, 11)];
};

const getRandomDay = () => getRandomInt(1, 28); // Adjust max day as needed

const getRandomFlooringType = () => {
  const flooringTypes = ["PARF", "COE", "BODY ONLY"];
  const randomIndex = getRandomInt(0, flooringTypes.length - 1);
  return flooringTypes[randomIndex];
};

const getRandomFlooringStatus = () => {
  const statusList = ["Issued", "Rejected", "Pending"];
  const randomIndex = getRandomInt(0, statusList.length - 1);
  return statusList[randomIndex];
};

const getRandomAAFStatus = () => {
  const aafStatusList = ["Pending", "Issued", "Rejected"];
  const randomIndex = getRandomInt(0, aafStatusList.length - 1);
  return aafStatusList[randomIndex];
};

const getRandomYear = () => {
  return new Date().getFullYear() + Math.floor(Math.random() * 2);
};

const getRandomHour = () => {
  return Math.floor(Math.random() * 24)
    .toString()
    .padStart(2, "0");
};

const getRandomMinute = () => {
  return Math.floor(Math.random() * 60)
    .toString()
    .padStart(2, "0");
};

const getRandomAction = () => {
  const actions = ["Ongoing", "Repossessed"];
  return actions[Math.floor(Math.random() * actions.length)];
};

export const generateDynamicData = (count) => {
  const dynamicData = [];
  const flooringStatusCounts = {
    Issued: 0,
    Rejected: 0,
    Pending: 0,
  };

  for (let i = 1; i <= count; i++) {
    const randomStatus = getRandomFlooringStatus();
    const randomAAFStatus = getRandomAAFStatus();
    flooringStatusCounts[randomStatus]++;
    dynamicData.push({
      key: i.toString(),
      applicationId: `123-456-789-${i}`,
      ApplicantName: `Applicant ${i + 1}`,
      ExpiryDate: `${
        Math.floor(Math.random() * 28) + 1
      } ${getRandomMonth()} ${getRandomYear()} | ${getRandomHour()}:${getRandomMinute()}`,
      dateTime: `${getRandomMonth()} ${getRandomDay()} 23:59`,
      flooringType: getRandomFlooringType(),
      vehChassisNo: { veh: `ABC${i}XYZ`, chassis: `MA3EFJC1S00${i}` },
      makeModel: {
        make: `Hyundai Avante ${i}1.6A GLS S`,
        model: `VTV MOTOR PTE LTD`,
      },
      intendedFloorAmt: getRandomInt(50000, 100000),
      adminFee: getRandomInt(50000, 100000),
      caseExp: `${getRandomMonth()} ${getRandomDay() + 6} 23:59`,
      IntPer30Days: `${Math.floor(Math.random() * 2000) + 50000}`,
      FloorAmt: `${Math.floor(Math.random() * 2000) + 50000}`,
      AdminFee: `${Math.floor(Math.random() * 500) + 1000}`,
      TotalIntTillDate: `${(Math.random() * 2 + 2).toFixed(2)}%`,
      TotalAmtPaid: `${Math.floor(Math.random() * 20000) + 10000}`,
      RedemptionAmt: `${Math.floor(Math.random() * 5000) + 30000}`,
      OngoingAction: getRandomAction(),
      flooringStatus: Object.entries(flooringStatusCounts).map(
        ([status, count]) => ({
          status,
          count,
        })
      ),
      aafStatus: randomAAFStatus,
      action: i % 2 === 0 ? "Ongoing" : "Pending",
    });
  }

  return dynamicData;
};

export const UploadedDocumentData = [
  {
    label: "Additional Document(s)",
    files: [
      {
        name: "TestPdf3.pdf",
        path: "public/uploads/flooring/6560858a9d9cf.pdf",
        extension: "pdf",
        size: "12.95KB",
      },
      {
        name: "Screenshot from 2023-10-22 21-12-53.png",
        path: "public/uploads/flooring/65655c90c0108.png",
        extension: "png",
        size: "193.44KB",
      },
    ],
  },
];

export const paymentHistoryData = [
  {
    date: "5 APR 2023",
    status: "Pending",
    description: "Payment Pending - Payment on 23/03/23",
    attachments: [{ type: "View", count: 3 }],
    amount: "$200.00",
    agentRemarks: "Picture provided is too blurry",
    action: true,
  },
  {
    date: "10 APR 2023",
    status: "Issued",
    description: "Payment Issued - Invoice #12345",
    attachments: [{ type: "View", count: 2 }],
    amount: "$150.00",
    agentRemarks: "Approved and processed",
    action: true,
  },
  {
    date: "15 APR 2023",
    status: "Rejected",
    description: "Payment Rejected - Incorrect account details",
    attachments: [],
    amount: "$300.00",
    agentRemarks: "Account number mismatch",
    action: false,
  },
  {
    date: "20 APR 2023",
    status: "Pending",
    description: "Payment Pending - Verification in progress",
    attachments: [{ type: "View", count: 1 }],
    amount: "$250.00",
    agentRemarks: "Awaiting verification",
    action: true,
  },
  {
    date: "25 APR 2023",
    status: "Issued",
    description: "Payment Issued - Bonus payment",
    attachments: [{ type: "View", count: 4 }],
    amount: "$100.00",
    agentRemarks: "Bonus for exceptional performance",
    action: true,
  },
];

export const PaymentSummaryData = [
  {
    floor_amount: 5000,
    interest_30_day: 150,
    interest_payable: 200,
    total_amount_paid: 5350,
    total_redemption_amount: 4800,
  },
];
